module.exports = __webpack_public_path__ + "img/high_five.7763a354.svg";